// AI Generated Component
import { Component, OnInit } from '@angular/core';
import { SeoRepoService } from '../../../services/seo-repo.service';
import { SessionService } from '@monsido/ng2/core/session/session.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { API_CONSTANTS } from '@client/app/core/constants/api.constant';
import {
    PagesFromSeoIssuesComponent,
} from '@client/app/pages/seo/dialogs/pages-from-seo-issues/pages-from-seo-issues.component';
import {
    SeoDialogPagesWithDuplicateTitleComponent,
} from '@client/app/pages/seo/dialogs/pages-with-duplicate-title/seo-dialog-pages-with-duplicate-title.component';

@Component({
    selector: 'seo-summary-common-opportunities',
    templateUrl: './common-opportunities.component.html',
    standalone: false,
})
export class SeoSummaryCommonOpportunitiesComponent implements OnInit {
    seoClassifications: any;
    pageCount: number = 0;
    seoIssuesHighestPageCount: number = 0;
    loading: boolean = true;
    seoIssues: any[] = [];

    progress: any = null;

    constructor (
        private seoRepoService: SeoRepoService,
        private sessionService: SessionService,
        private monEventService: MonEventService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        this.seoClassifications = API_CONSTANTS.SEO.CLASSIFICATION;
        this.pageCount = 0;
        this.seoIssuesHighestPageCount = 0;
        this.loading = true;

        if (this.sessionService.domain?.crawl_history) {
            this.pageCount = this.sessionService.domain.crawl_history.page_count;
            this.pageCount = this.pageCount + this.sessionService.domain.crawl_history.documents_count;
        }

        this.getSeoIssues();
    }

    getSeoIssues (): void {
        const params = {
            page_size: 7,
            page: 1,
            sort_by: 'pages_count',
            sort_dir: 'desc',
            status: 'active',
        };

        this.progress = this.seoRepoService.getAll(params)
            .then((data) => {
                if (data.length > 0) {
                    this.seoIssuesHighestPageCount = data[0].pages_count;
                }
                this.seoIssues = data.filter((reportData) => {
                    return reportData.pages_count > 0;
                });
            })
            .catch(() => {
                // Handle error
            })
            .finally(() => {
                this.loading = false;
            });
    }

    ignoreIssue (issue: any): void {
        issue.ignored = true;
        this.seoRepoService.update(issue.id, issue).then(() => {
            this.getSeoIssues();
        }).catch(() => {
            // Handle error
        });
    }

    getPagesFromSeoIssue (issue: any): void {
        let dialogBody: any;

        switch (issue.name) {
            case 'seo_duplicate_title':
            case 'seo_duplicate_h1':
                dialogBody = SeoDialogPagesWithDuplicateTitleComponent;
                break;
            default:
                dialogBody = PagesFromSeoIssuesComponent;
        }

        const params = {
            body: dialogBody,
            size: 'lg',
            data: {
                issue: issue,
                pageCount: this.pageCount,
            },
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }
}
